import { isTeammateATeamMember } from "@repo/app-types/entities/teammate";
import type { FC } from "react";
import { Navigate, useParams } from "react-router";
import { appPaths } from "../../app/appPaths.js";
import { performanceSections } from "../../app/navigation/performanceSections.js";
import { requireRouteParam } from "../../app/routeParams.js";
import { useAppSelector } from "../../hooks/hook.js";
import { selectTeammate } from "../teammate/teammateSlice.js";

/**
 * Redirects a playbook's index to its landing tab: Team for everyone but team
 * members, who land on their own teammate page.
 */
export const PerformanceDefaultRedirect: FC = () => {
  const playbookId = requireRouteParam(useParams(), "playbookId");
  const currentTeammate = useAppSelector(selectTeammate);

  return (
    <Navigate
      to={
        currentTeammate && isTeammateATeamMember(currentTeammate)
          ? appPaths.teammate.build({
              playbookId,
              teammateId: currentTeammate.id,
            })
          : performanceSections.team.path.build({ playbookId })
      }
      replace
    />
  );
};
